module.exports = __webpack_public_path__ + "img/caseTitle2.747d8b2d.png";